"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var vue_class_component_1 = __importDefault(require("vue-class-component"));
var RequestData_1 = __importDefault(require("../../classes/RequestData"));
var event_bus_1 = require("../../event-bus");
var echo_1 = __importStar(require("../../echo"));
var request_1 = __importDefault(require("../../request"));
var UnitsMixin = /** @class */ (function (_super) {
    __extends(UnitsMixin, _super);
    function UnitsMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.units = new RequestData_1.default();
        _this.currentDistrict = {};
        return _this;
    }
    UnitsMixin.prototype.created = function () {
        event_bus_1.EventBus.$on(event_bus_1.events.unit.create, this.onUnitCreateEvent)
            .$on(event_bus_1.events.unit.rename, this.onUnitRenameEvent)
            .$on(event_bus_1.events.unit.district.update, this.onUnitDistrictUpdate)
            .$on(event_bus_1.events.unit.delete, this.onUnitDeleteEvent);
        echo_1.default.channel(echo_1.channels.unit)
            .listen(echo_1.events.unit.create, this.requestUnits)
            .listen(echo_1.events.unit.rename, this.updateUnit)
            .listen(echo_1.events.unit.delete, this.requestUnits);
    };
    UnitsMixin.prototype.beforeDestroy = function () {
        event_bus_1.EventBus.$off(event_bus_1.events.unit.create, this.onUnitCreateEvent)
            .$off(event_bus_1.events.unit.rename, this.onUnitRenameEvent)
            .$off(event_bus_1.events.unit.district.update, this.onUnitDistrictUpdate)
            .$off(event_bus_1.events.unit.delete, this.onUnitDeleteEvent);
        echo_1.default.leave(echo_1.channels.unit);
    };
    UnitsMixin.prototype.requestUnits = function (page) {
        return request_1.default.unit.all(this.currentDistrict.id || 0, this.units.search, page || this.units.pagination.current_page, this.updateUnits);
    };
    UnitsMixin.prototype.requestUnitsFirstPage = function () {
        return this.requestUnits(1);
    };
    UnitsMixin.prototype.onUnitCreateEvent = function (unit) {
        return request_1.default.unit.create(unit, this.requestUnits);
    };
    UnitsMixin.prototype.onUnitRenameEvent = function (unit) {
        return request_1.default.unit.rename(unit.id, unit.name, this.updateUnit);
    };
    UnitsMixin.prototype.onUnitDistrictUpdate = function (data) {
        request_1.default.unit.district.update(data.unit_id, data.district_id, this.updateUnit);
    };
    UnitsMixin.prototype.onUnitDeleteEvent = function (unit) {
        return request_1.default.unit.delete(unit.id, this.requestUnits);
    };
    UnitsMixin.prototype.onSearchPhraseInput = function (search) {
        this.updateSearchPhrase(search);
    };
    UnitsMixin.prototype.updateUnits = function (units, pagination) {
        this.units = this.units
            .setArray(units)
            .setPagination(pagination);
    };
    UnitsMixin.prototype.updateUnit = function (unit) {
        this.units = this.units.updateArray(unit);
    };
    UnitsMixin.prototype.updateSearchPhrase = function (search) {
        this.units = this.units.setSearch(search);
    };
    UnitsMixin = __decorate([
        vue_class_component_1.default
    ], UnitsMixin);
    return UnitsMixin;
}(vue_property_decorator_1.Vue));
exports.default = UnitsMixin;
